import { configureStore } from '@reduxjs/toolkit';
import { modalsSlice } from './modals';

export const store = configureStore({
  reducer: {
    [modalsSlice.name]: modalsSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
